export default __webpack_public_path__ + "static/media/Dr.-Mohamed-Al-Hemairy.8cce856c.png";